import React from "react";

import {OrganisationId} from "common/types/organisation";

import Results from "./results";
import BatchSelector from "./batch_selector";

import {
  LlmRunBatchInfo,
  LlmRunScore,
} from "../../../common/flowmaster/types/llm_run";

interface Props {
  organisationId: OrganisationId;
  batches: LlmRunBatchInfo[];
  selectedBatches: string[];
  setSelectedBatches: (batches: string[]) => void;
  runScores: LlmRunScore[];
}

export default function Scores({
  organisationId,
  batches,
  selectedBatches,
  setSelectedBatches,
  runScores,
}: Props) {
  return (
    <div>
      <div
        style={{
          borderBottom: "1px solid #ccc",
          padding: "0 1em",
          paddingBottom: "0.5em",
        }}
      >
        <BatchSelector
          selectedBatches={selectedBatches}
          batches={batches}
          setSelectedBatches={setSelectedBatches}
        />
      </div>
      <div style={{marginTop: "1em", padding: "0 1em"}}>
        <Results
          organisationId={organisationId}
          runScores={runScores}
          batches={batches}
        />
      </div>
    </div>
  );
}
